import { Skeleton } from "@/components/ui/skeleton";

export function FlagListSkeleton() {
  return <div role="status" aria-label="Loading flags" className="space-y-3">
    <div className="flex flex-wrap gap-1">
      {[12, 20, 16, 14].map(width => <Skeleton key={width} className="h-5 rounded-full" style={{ width: `${width * 4}px` }} />)}
    </div>
    <Skeleton className="h-9 w-full" />
    <div className="space-y-3 px-2 pt-1">
      {Array.from({ length: 8 }, (_, index) => <div key={index} className="space-y-1.5">
        <Skeleton className="h-3.5" style={{ width: `${55 + ((index * 17) % 35)}%` }} />
        <Skeleton className="h-3 w-20" />
      </div>)}
    </div>
  </div>;
}

export function TableSkeleton({ rows = 4, label }: { rows?: number; label: string }) {
  return <div role="status" aria-label={label} className="space-y-2">
    <Skeleton className="h-4 w-1/3" />
    {Array.from({ length: rows }, (_, index) => <div key={index} className="flex gap-3 border-t pt-2">
      <Skeleton className="h-4 w-1/4" />
      <Skeleton className="h-4 w-12" />
      <Skeleton className="h-4 w-1/4" />
      <Skeleton className="h-4 flex-1" />
    </div>)}
  </div>;
}
